import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Admin from "@/pages/Admin";

/**
 * Gates the admin panel behind auth. Unauth or non-admin users are
 * silently redirected to /adminX/login (no navbar link exposes this path).
 */
export default function AdminXPage() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-zinc-500 text-sm">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/adminX/login" replace />;
  return <Admin />;
}
